import { axios } from "../lib";
import * as endpoints from "./apiEndpoints";

class ContactService {
  static loadContacts() {
    const url = `${endpoints.BASE_URL}${endpoints.CONTACTS}`;
    return axios.get(url).then((response) => response.data);
  }

  static getContact(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTACTS}/${id}`;
    return axios.get(url).then((response) => response.data);
  }

  static createContact(contact) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTACTS}`;

    const body = {
      contact
    };

    return axios.post(url, body).then((response) => response.data);
  }

  static updateContact(contact) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTACTS}/${contact.id}`;

    const body = {
      contact
    };

    return axios.put(url, body).then((response) => response.data);
  }

  static deleteContact(id) {
    const url = `${endpoints.BASE_URL}${endpoints.CONTACTS}/${id}`;

    return axios.delete(url).then((response) => response.data);
  }
}

export default ContactService;
